
import { Component, Vue, Prop } from "vue-property-decorator";
import { TreeNode } from "@/types/tree";
import {
  calculateElementPositionOnCanvas,
  listenForPositionChangesAndGetNewPosition,
  ElementPositionOnCanvas,
  getWrapperStyle,
  getOutlineStyle
} from "@/futurelayer/canvas/canvas-controls/element-positioning";
import { FUTURELAYER_HEADER_ELEMENT_TYPE } from "@/futurelayer/headers-footers/headers-footers";
import { startEditingHeaderOrFooterElement } from "@/futurelayer/headers-footers/headers-footers";

@Component
export default class FutureLayerHoveredHeaderOrFooter extends Vue {
  @Prop()
  element!: TreeNode;

  elementPositionOnCanvas: ElementPositionOnCanvas = false;
  cleanupListeners: () => void = () => {};

  mounted() {
    this.elementPositionOnCanvas = calculateElementPositionOnCanvas(
      this.element
    );

    this.cleanupListeners = listenForPositionChangesAndGetNewPosition(
      this.element,
      (newPosition: ElementPositionOnCanvas) => {
        this.elementPositionOnCanvas = newPosition;
      }
    );
  }

  beforeDestroy() {
    this.cleanupListeners();
  }

  get cssStyleForWrapper(): Record<string, string> {
    return getWrapperStyle(this.elementPositionOnCanvas);
  }

  get cssStyleForOutline(): Record<string, string> {
    return getOutlineStyle(this.elementPositionOnCanvas);
  }

  get cssStyleForControls(): Record<string, string> {
    if (!this.elementPositionOnCanvas) {
      return { display: "none" };
    }

    return {
      left: "0px",
      top: "0px",
      width: this.elementPositionOnCanvas.width,
      height: this.elementPositionOnCanvas.height
    };
  }

  get isHeader(): boolean {
    return this.element.data.type === FUTURELAYER_HEADER_ELEMENT_TYPE;
  }

  loading = false;

  async startEditing() {
    this.loading = true;
    await startEditingHeaderOrFooterElement(this.element.id);
    this.loading = false;
  }
}
